import GithubSourceIcon from "../../assets/components/sources/GithubSourceIcon";

const GithubLogomark = ({ height }: { height: number }) => {
  return <GithubSourceIcon height={height} />;
};

export default GithubLogomark;
